import { connect } from 'react-redux';
import Navigation from './Navigation';

import { openCancelReservationScreen } from '../../actions/cancelling';
import { clearSession } from '../../actions/session';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  organizationLogoUrl: state.organization.logoUrl,
  viaSso: state.session.viaSso
});

const mapDispatchToProps = dispatch => ({
  openCancelReservationScreen() {
    dispatch(openCancelReservationScreen());
  },
  logout: (viaSso) => {
    dispatch(clearSession)(viaSso);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.jsx